import dayjs from 'dayjs'
import { ArrowRightIcon } from 'lucide-react'

import { useCaseActionHistoryDrawerStore } from '@/pages/_app/dashboard/store'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

export interface CellContentCompletedProps {
  taskId: number
  completedBy: string
  completedAt: string
}

export const CellContentCompleted = ({ taskId, completedBy, completedAt }: CellContentCompletedProps) => {
  const { open: openCaseHistoryDrawer } = useCaseActionHistoryDrawerStore()

  const handleClickButton = () => {
    openCaseHistoryDrawer({
      taskId,
    })
  }

  return (
    <Button
      type="button"
      variant="default"
      className={cn(
        'flex items-center',
        'text-xs font-normal text-blue-900',
        'bg-blue-50',
        'rounded-[5px]',
        'w-fit',
        'h-7',
        'px-2 py-1.5',
        'hover:bg-blue-100'
      )}
      onClick={handleClickButton}
    >
      <span>{completedBy}</span>
      <span className={cn('inline-block', 'mx-1')}>&middot;</span>
      <span>{dayjs.utc(completedAt).format('MM/DD/YYYY')}</span>
      <span className={cn('inline-block', 'ml-1')}>
        <ArrowRightIcon size={16} />
      </span>
    </Button>
  )
}
